<div id="forScroll"></div>
<div class="service-provider">
    <div class="mainWrap">
        <div class="headerSection">
            <div class="titleWrap">
                Services We Provide
            </div>
         <!--    <div class="descWrap">
                Our Digital Transformation Services
            </div> -->
        </div>
        <div class="bodySection">
            <div class="rowWrap" *ngFor = "let i of services">
                <div class="card">
                    <div class="imageWrap">
                        <img src="{{i.imageUrl}}">
                    </div>
                    <div class="textWrap">
                        <div class="titleRowWrap">
                           {{i.title}}
                        </div>
                        <div class="descRowWrap">
                           {{i.desc}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>